import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full h-full max-md:bg-secondary px-4 pt-6 md:pt-2 pb-2 overflow-y-auto no-scrollbar" }
const _hoisted_2 = { class: "md:hidden flex justify-between items-center mb-6" }
const _hoisted_3 = { class: "w-[74px]" }
const _hoisted_4 = { class: "text-brown font-semibold text-2xl" }
const _hoisted_5 = { class: "flex justify-center" }
const _hoisted_6 = { class: "bg-white rounded-[20px] border border-ternary max-w-[812px] flex-1 flex flex-col items-center gap-10 py-6 px-4 relative" }
const _hoisted_7 = { class: "flex flex-col gap-4 items-center" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text-muted text-xl leading-[24px] font-semibold" }
const _hoisted_10 = { class: "flex flex-col gap-4 w-full sm:w-[480px]" }
const _hoisted_11 = { class: "bold-text" }
const _hoisted_12 = { key: 2 }

import userImage from "@/assets/icons/profile.svg";
import { useUserStore } from "@/stores/userStore";
import { useI18n } from "vue-i18n";
import router from "@/router";
import { onMounted, ref } from "vue";
import { ROUTE_NAMES } from "@/constants/routeNames";
import AuthModal from "@/views/Auth/components/AuthModal.vue";
import SubscriptionModal from "@/views/Auth/components/SubscriptionModal.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import { useSafeBack } from "@/utils/useSafeBack";
import NotificationComponent from "@/components/notifications/NotificationComponent.vue";
import { PREMIUM_CALCULATORS, PremiumCalculator } from "@/types/premiumTypes";
import ActiveSubscriptionCard from "@/views/Auth/components/ActiveSubscriptionCard.vue";
import SubscriptionCard from "@/views/Auth/components/SubscriptionCard.vue";
import { useRoute } from "vue-router";
import FamilyTable from "@/views/Auth/components/FamilyTable.vue";
import DestinyMatrixPurchadesDatesTable from "@/views/Auth/components/DestinyMatrixPurchadesDatesTable.vue";
import OutlineButton from "@/components/buttons/OutlineButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserView',
  setup(__props) {

const userStore = useUserStore();
const { t } = useI18n();
const { safeBack } = useSafeBack();
const route = useRoute();

const ALL_PREMIUM_CALCULATORS = Object.values(PREMIUM_CALCULATORS);
const defaultSelectedSubscription = ref<PremiumCalculator>();
const showSubscribeModal = ref(false);
const showAuthModal = ref(false);
const loadingState = ref<Record<string, boolean>>({});

onMounted(() => {
  if (userStore.user === null) {
    showAuthModal.value = true;
    return;
  }
  // fetch new user info when opening this page
  userStore.updateUserInfo(true);

  const calculator = route.query.openCalculator;
  if (calculator) {
    defaultSelectedSubscription.value = calculator as PremiumCalculator;
    showSubscribeModal.value = true;
    router.replace({ query: { ...route.query, openCalculator: undefined } });
  }
});

async function logout() {
  try {
    loadingState.value["logout"] = true;
    await userStore.logout();
    await router.replace({ name: ROUTE_NAMES.HOME });
  } catch (e) {
    console.error(e);
  } finally {
    loadingState.value["logout"] = false;
  }
}

function openSubscriptionModal(subscription: PremiumCalculator) {
  defaultSelectedSubscription.value = subscription;
  showSubscribeModal.value = true;
}

async function handleCancelSubscription(subscription: PremiumCalculator) {
  try {
    loadingState.value["cancel-subscription"] = true;
    await userStore.cancelSubscription(subscription);
  } catch (e) {
    console.error(e);
  } finally {
    loadingState.value["cancel-subscription"] = false;
  }
}

function handleCloseAuthModal() {
  if (userStore.user !== null) {
    showAuthModal.value = false;
  } else {
    router.replace({ name: ROUTE_NAMES.HOME });
  }
}

function handleBack() {
  safeBack(ROUTE_NAMES.HOME);
}

const isLoading = (id: string): boolean => {
  return loadingState.value[id] ?? false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BackButton, { onClicked: handleBack })
      ]),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("profile.title")), 1),
      _createVNode(OutlineButton, {
        class: "h-8 w-[74px]",
        isLoading: isLoading('logout'),
        "btn-text": _unref(t)('buttons.auth.logout'),
        onClick: logout
      }, null, 8, ["isLoading", "btn-text"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(OutlineButton, {
          class: "h-11 w-24 hidden md:block absolute top-4 right-4",
          isLoading: isLoading('logout'),
          "btn-text": _unref(t)('buttons.auth.logout'),
          onClick: logout
        }, null, 8, ["isLoading", "btn-text"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            src: _unref(userImage),
            class: "size-[120px]",
            alt: "user image"
          }, null, 8, _hoisted_8),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(userStore).user?.email ?? "fengshui@gmail.com"), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)("subscription.plan-title")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ALL_PREMIUM_CALCULATORS), (premiumCalculator) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: premiumCalculator }, [
              (_unref(userStore).userHasSubscription(premiumCalculator))
                ? (_openBlock(), _createBlock(ActiveSubscriptionCard, {
                    key: 0,
                    subscription: _unref(userStore).user.subscriptions.find((s) => s.calculator === premiumCalculator)!,
                    isLoading: isLoading('cancel-subscription'),
                    onCancelSubscription: ($event: any) => (handleCancelSubscription(premiumCalculator))
                  }, null, 8, ["subscription", "isLoading", "onCancelSubscription"]))
                : (_openBlock(), _createBlock(SubscriptionCard, {
                    key: 1,
                    subscriptionName: premiumCalculator,
                    onShowSubscribeModal: ($event: any) => (openSubscriptionModal(premiumCalculator))
                  }, null, 8, ["subscriptionName", "onShowSubscribeModal"]))
            ], 64))
          }), 128))
        ])
      ])
    ]),
    (
        _unref(userStore).user !== null &&
        _unref(userStore).userHasSubscription(_unref(PREMIUM_CALCULATORS).activations)
      )
      ? (_openBlock(), _createBlock(FamilyTable, { key: 0 }))
      : _createCommentVNode("", true),
    (
        _unref(userStore).user !== null &&
        !_unref(userStore).userHasSubscription(_unref(PREMIUM_CALCULATORS).destinyMatrix) &&
        _unref(userStore).user?.products['destiny_matrix']?.length > 0
      )
      ? (_openBlock(), _createBlock(DestinyMatrixPurchadesDatesTable, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(AuthModal, {
      show: showAuthModal.value,
      onClose: handleCloseAuthModal
    }, null, 8, ["show"]),
    (showSubscribeModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(SubscriptionModal, {
            show: showSubscribeModal.value,
            defaultSelected: defaultSelectedSubscription.value,
            currentSubscriptions: _unref(userStore).user.subscriptions,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (showSubscribeModal.value = false))
          }, null, 8, ["show", "defaultSelected", "currentSubscriptions"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(NotificationComponent)
  ]))
}
}

})